module.exports = __webpack_public_path__ + "static/media/char-2.87ab51e9.svg";